const triggerScroll = () => window.parent.postMessage('trigger scroll', '*');

export default triggerScroll;
